import { css } from '@emotion/react';
import React from 'react';

interface TitleProps {
  children: React.ReactNode;
  level?: 1 | 2 | 3;
  color?: string;
  fontSize?: string;
}

const titleCss = [
  // H1
  css({
    fontFamily: "'Poppins-Bold', sans-serif",
    fontSize: 'clamp(1rem, 5vw, 1.25rem)',
    fontWeight: 500,
    color: 'var(--ion-color-secondary)',
    padding: '0',
    margin: '0',
  }),
  // H2
  css({
    fontFamily: "'Nunito-Bold', sans-serif",
    fontSize: 'clamp(0.875rem, 5vw, 0.9375rem)',
    color: 'var(--ion-color-secondary)',
    padding: '0',
    margin: '0',
  }),
  // H3
  css({
    fontFamily: "'Nunito-Regular', sans-serif",
    fontSize: 'clamp(0.75rem, 4vw, 0.8125rem)',
    color: 'var(--ion-color-secondary)',
    padding: '0',
    margin: '0',
    // add kerning
    letterSpacing: '0.05em',
  }),
];

export const Title: React.FC<TitleProps> = ({ children, color, level = 1, fontSize }) => {
  const H = `h${level}` as keyof React.JSX.IntrinsicElements;
  const cssRules = [titleCss[level - 1], css({ lineHeight: '1.5em', whiteSpace: 'normal' })];
  const extraRule: Record<string, string> = {};
  if (color) {
    extraRule['color'] = color;
  }
  if (fontSize) {
    extraRule['fontSize'] = fontSize;
  }
  if (extraRule) {
    cssRules.push(css(extraRule));
  }

  return <H css={cssRules}>{children}</H>;
};
